import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { IUser } from 'app/shared/Domains/IUser';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import { Category } from '../domain/Category';
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
  selector: 'app-product-categories',
  templateUrl: './product-categories.component.html',
  host: { "(window:keyup)": "hotkeys($event)" },
  styleUrls: ['./product-categories.component.css']
})
export class ProductCategoriesComponent implements OnInit {
  @ViewChild("searchName", { static: false }) searchNameInput: ElementRef;
  loading: boolean = false;
  category: Category;
  user: IUser;
  categories: any[];
  sourceCategories: any[];
  first: number = 0;

  constructor(
    private LanguageService: LanguageService,
    private breadcrumbService: BreadcrumbService,
    private route: Router,
    private appServiceManager: AppServiceManager,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
  ) {
    this.breadcrumbService.setItems([
      { label: 'Products-Categories' }
    ]);
  }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("ProductCategoriesComponent", label);
  }
  ngOnInit() {
    this.categories = [];
    this.category = new Category();
    this.user = AuthService.getLoggedInUser();
    this.getProductCategories();
  }

  ngAfterViewInit() {
    this.searchNameInput.nativeElement.focus();

  }

  viewCategory(category) {
    this.route.navigateByUrl('product-category/' + category._id)
  }

  getProductCategories() {
    this.loading = true;
    this.appServiceManager.get(`products/category/company/${this.user.company}/branch/${this.user.branch}`).subscribe((res: any) => {
      if (res.length > 0) {
        this.categories = res;
        this.sourceCategories = res;
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
      }
      this.loading = false;
    },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  deleteCategory(category) {
    this.confirmationService.confirm({
      message: "Are you sure you want to Delete ?",
      accept: () => {
        this.loading = true;
        this.appServiceManager.delete('products/category/' + category._id).subscribe((res: any) => {
          if (res.status === true) {
            this.DeleteCategory(category);
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Successfully Deleted' });
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
          this.loading = false;
          this.categories = [...this.categories]
        },
          (error) => {
            this.loading = false;
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
      }
    });
  }
  DeleteCategory(category) {
    let categories = [...this.categories];
    let index = this.categories.indexOf(category);
    if (index > -1) {
      categories.splice(index, 1);
      return this.categories = categories;
    }
  }

  searchLocal(value, type) {
    let matchedName = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "") {
        this.categories = Object.assign([], this.sourceCategories);
      }
      if (!value) {
        this.categories = Object.assign([], this.sourceCategories);
      }
      if (value != "") {
        if (type === "name") {
          matchedName = Object.assign([], this.sourceCategories).filter(
            cust => cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
        }

        const distinct = (value, index, self) => {
          return self.indexOf(value) === index;
        }
        const source = matchedName;
        this.categories = source.filter(distinct);

        if (this.categories.length === 0) {
          this.categories = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {
          this.first = 0;
          if (this.categories.length === 1) {
            this.first = 0;
          }
          this.categories = [...this.categories];
        }
      }
    } else {
      this.categories = Object.assign([], this.sourceCategories);
      this.categories = [...this.categories];
    }
  }

  clear() {
    this.category = new Category();
    this.searchLocal("", "");
    this.first = 0;
  }

  onPageChange(event) {
    this.first = event.first;
  }

  hotkeys($event) {
    if ($event.keyCode == 113) {
      this.route.navigateByUrl("/product-category");

    }
  }

}
